import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as Yup from 'yup';

import useRequest from '@common/react/hooks/useRequest';

import { AppRoute } from '@app/components/LocalCommon/const';
import PasswordShowHide from '@app/components/LocalCommon/PasswordShowHide/PasswordShowHide';
import CustomInput from '@app/components/UI/CustomInput/CustomInput';
import { TypeRecover } from '@app/components/UI/Login/RecoverForm';
import RecoverFormLayout from '@app/components/UI/Login/RecoverFormLayout';

interface Props {
	data: Record<'phoneNumber', string> | Record<'email', string>;
	onChangeTypeRecover: (val: TypeRecover | null) => void;
}

const mailIcon = require('@app/images/icons/mail.svg');
const lockIcon = require('@app/images/icons/lock.svg');

const passwordRules = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;

const VerifyCodeAndSetPasswordForm: React.FC<Props> = ({ data, onChangeTypeRecover }) => {
	const request = useRequest();
	const navigate = useNavigate();

	return (
		<RecoverFormLayout
			title="Reset Password"
			initialValues={{
				code: '',
				password: '',
				passwordConfirmation: '',
			}}
			validationSchema={Yup.object({
				code: Yup.string().required('Code is a required field'),
				password: Yup.string().matches(passwordRules, { message: 'See password requirements' }).required('Password is a required field'),
				passwordConfirmation: Yup.string()
					.oneOf([Yup.ref('password'), null], 'Passwords must match')
					.required('Password confirmation is a required field'),
			})}
			onBack={() => onChangeTypeRecover(null)}
			onSubmit={(values) => (
				request((Object.keys(data).some((value) => value === 'phoneNumber') ? 'setPasswordAndLoginByPhoneNumber' : 'setPasswordAndLoginByEmail'), {
					code: values.code,
					password: values.password,
					...data,
				})
					.then((val) => {
						navigate(AppRoute.PETS);
					})
			)}
			successfulMessage="Password changed successfully!"
			render={(formikBag) => (
				<div className="login-form__fields">
					{/* Inputs to trick browser autofill */}
					<input type="text" autoComplete="username" style={{ display: 'none' }} />
					<input type="password" autoComplete="new-password" style={{ display: 'none' }} />

					<CustomInput
						name="code"
						placeholder="Code*"
						formikBag={formikBag}
						prefixIcon={mailIcon}
						autoComplete="new-password"
					/>
					<CustomInput
						name="password"
						placeholder="New Password*"
						formikBag={formikBag}
						removeSpace
						handleOnChange={(e) => formikBag.setFieldValue('password', e.target.value)}
						prefixIcon={lockIcon}
						component={PasswordShowHide}
						autoComplete="new-password"
					/>
					<CustomInput
						name="passwordConfirmation"
						placeholder="Repeat New Password*"
						formikBag={formikBag}
						removeSpace
						handleOnChange={(e) => formikBag.setFieldValue('passwordConfirmation', e.target.value)}
						prefixIcon={lockIcon}
						component={PasswordShowHide}
						autoComplete="new-password"
					/>
				</div>
			)}
		/>
	);
};

export default VerifyCodeAndSetPasswordForm;
